import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  topContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    marginTop: '1rem',
    borderRadius: '0.75rem',
    border: '1px solid #DCDFE1',
    padding: '1.5rem',
  },

  header: {
    display: 'flex',
    justifyContent: 'end',
  },

  boxContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #DCDFE1',
    borderRadius: '0.5rem',
    padding: '0.5rem',
  },
}));

export default useStyles;
